import styled, { css } from 'styled-components';
import Select from 'react-select';
import { NavLink } from 'react-router-dom';

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${props => props.alignitems};
  justify-content: ${props => props.justifycontent};
  width: ${props => props.width};
  margin: ${props => props.margin};
  text-align: ${props => props.textalign};
`;

export const Row = styled.div`
  display: flex;
  align-items: ${props => props.alignitems};
  justify-content: ${props => props.justifycontent};
  margin: ${props => props.margin};
  width: ${props => props.width};
`;

export const Title = styled.h1`
  color: ${props => (props.white ? '#fff' : '#2b2b2b')}
  font-family: "Ubuntu", sans-serif;
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  font-size: 38px;
  letter-spacing: .1em;
  text-transform: uppercase;
  @media (max-width: 400px) {
    font-size: 34px;
    text-align: center;
  }
  ${props =>
    props.orange &&
    css`
      color: #ffaf77;
      font-size: ${props => props.small && '18px'};
    `};
  ${props =>
    props.profession &&
    css`
      font-weight: 400;
      font-size: 35px;
    `};
   ${props =>
     props.professionsub &&
     css`
       font-weight: 400;
       font-size: 28px;
     `};
`;

export const Subtitle = styled.h2`
  color: #fff;
  font-family: 'Ubuntu', sans-serif;
  font-weight: 400;
  font-size: 24px;
  margin: ${props => props.margin || '1em 0'};
  @media (max-width: 400px) {
    font-size: 28px;
  }
  ${props =>
    props.findce &&
    css`
      line-height: 1.8em;
      @media (max-width: 400px) {
        font-size: 22px;
      }
    `};
  ${props =>
    props.formtext &&
    css`
      font-weight: 400;
      font-size: 48px;
    `};
`;

export const Text = styled.p`
  color: ${props => (props.white ? '#fff' : '#2b2b2b')};
  font-family: 'Ubuntu', sans-serif;
  font-weight: ${props => props.fontweight || '400'};
  font-size: 18px;
  text-align: ${props => props.textalign};
  margin: ${props => props.margin};
  line-height: ${props => props.lineheight || '2em'};
  cursor: ${props => props.footer && 'pointer'};
  ${props =>
    props.protitle &&
    css`
      text-transform: uppercase;
      font-size: 22px;
      font-weight: 600;
      margin: ${props => props.margin || '0.5em 0 0.25em 0'};
    `};
  ${props =>
    props.instructortitle &&
    css`
      font-size: 20px;
      font-weight: 600;
      margin: 0;
      line-height: 1em;
      color: #ffaf77;
    `};
  ${props =>
    props.testimony1 &&
    css`
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 2em;
    `};
  ${props =>
    props.testimony2 &&
    css`
      font-size: 20px;
      font-weight: 400;
      line-height: 1.5em;
      margin: 0.25em 0;
    `};
  ${props =>
    props.profession &&
    css`
      font-size: 30px;
      line-height: 1.5em;
      margin: 0.25em 0;
    `};
  ${props =>
    props.error &&
    css`
      color: red;
      font-size: 0.8em;
    `};
  ${props =>
    props.licenseerror &&
    css`
      color: #4078c0;
      font-size: 0.8em;
    `};
`;

export const Label = styled.label`
  font-family: 'Ubuntu', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #989898;
  ${props =>
    props.add &&
    css`
      color: #4078c0;
      cursor: pointer;
    `};
  ${props =>
    props.loginButton &&
    css`
      color: #ffaf77;
      cursor: pointer;
    `};
  ${props =>
    props.expired &&
    css`
      color: #ffaf77;
      z-index: 1000000;
      cursor: pointer;
      line-height: 1.5em;
    `};
`;

export const StyledSelect = styled(Select)`
  width: ${props => (props.form ? '185px' : '195px')};
  height: ${props => props.form && '38px'};
  border-radius: 6px;
  border-radius: 5px;
  margin: 0.5em 0;
  margin-right: 0.5em;
  outline: none;
  background: #fff;
  ${props =>
    props.large &&
    css`
      width: 375px;
      height: 38px;
      border-radius: 6px;
      background-color: rgba(0, 0, 0, 0);
      @media (max-width: 1100px) {
        width: 370px;
        height: 38px;
      }
      @media (max-width: 780px) {
        width: 265px;
      }
    `}
  @media (max-width: 500px) {
    width: 165px;
  }
`;

export const UserWarn = styled.div`
  position: absolute;
  top: ${props => props.top || '0em'};
  bottom: 0em;
  left: ${props => props.left};
  right: ${props => props.right || 0};
  ${props =>
    props.form &&
    css`
      top: -2.1em;
      left: 6.5em;
    `};
`;

export const I = styled.i`
  font-size: 1em;
  cursor: pointer;
  padding: 1.1em 1.5em;
  margin-left: 0.75em;
  background-color: rgba(255, 255, 255, 0.6);
  ${props =>
    props.social &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      padding: 0.5em;
      border: 0.5px solid #ccc;
      border-radius: 100%;
      margin-left: 0;
      margin-right: 0.5em;
      background-color: rgba(255, 255, 255, 0);
      color: #fff;
    `};
`;

export const Input = styled.input`
  width: 485px;
  padding: 0 0.5em;
  height: 50px;
  border: ${props => props.bordererror || '1px solid #ccc'};
  display: ${props => props.display || 'flex'};
  outline: none;
  margin: 0.5em 0;
  @media (max-width: 1100px) {
    width: 315px;
    height: 40px;
  }

  ${props =>
    props.large &&
    css`
      height: 175px;
    `};
  ${props =>
    props.testimonial &&
    css`
      border-radius: 4px 0 0 4px;
      width: 110px;
      @media (max-width: 720px) {
        width: 175px;
      }
    `};
  ${props =>
    props.footer &&
    css`
      width: 200px;
      background-color: rgba(0, 0, 0, 0);
      color: #fff;
    `};
  ${props =>
    props.login &&
    css`
      width: 365px;
      height: 38px;
      border-radius: 6px;
      background-color: rgba(0, 0, 0, 0);
      @media (max-width: 1100px) {
        width: 365px;
        height: 38px;
      }
      @media (max-width: 780px) {
        width: 275px;
      }
    `};
  ${props =>
    props.loginSmall &&
    css`
      width: 168px;
      height: 38px;
      margin-right: 0;
      border-radius: 6px;
      background-color: rgba(0, 0, 0, 0);
      @media (max-width: 1100px) {
        width: 168px;
        height: 38px;
      }
    `};
`;

export const TextArea = styled.textarea`
  height: 175px;
  width: 485px;
  padding: 0.25em 0.5em;
  border: 1px solid #ccc;
  display: flex;
  margin: 0.5em 0;
  outline: none;
  @media (max-width: 1100px) {
    width: 315px;
  }
`;

export const FormSelect = styled.select`
  width: 100%;
  max-width: 350px;
  height: 65px;
  color: #fff;
  font-family: 'Ubuntu', sans-serif;
  margin: 0;
  font-weight: 400;
  font-size: 22px;
  background: rgba(0, 0, 0, 0);
  display: flex;
  align-items: center;
  outline: none;
  border-radius: 0px;
  margin: 0 0.5em;
  border: 1.5px solid #fff;
  @media (max-width: 780px) {
    margin: 0.5em;
  }
  ${props =>
    props.small &&
    css`
      max-width: 250px;
      @media (max-width: 780px) {
        max-width: 350px;
      }
    `};
  ${props =>
    props.home &&
    css`
      width: 175px;
      height: 45px;
      font-size: 18px;
      @media (max-width: 780px) {
        max-width: 350px;
      }
    `};
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 300px;
  padding: 0.5em;
  line-height: 1;
  outline: none;
  cursor: pointer;
  margin: ${props => props.margin};
  border: ${props =>
    props.primary ? '1.5px solid #2b2b2b' : '1.5px solid #fff'};
  background-color: ${props =>
    props.primary ? '#C8D9FD' : 'rgba(0, 0, 0, 0)'};
  color: ${props => (props.primary ? '#2b2b2b' : '#fff')};
  font-family: 'Ubuntu', sans-serif;
  text-transform: uppercase;
  font-size: 1.2em;
  cursor: pointer;
  @media (max-width: 400px) {
    font-size: 1.2em;
  }
  ${props =>
    props.login &&
    css`
      width: 100%;
      height: 50px;
      border-radius: 6px;
      background: #ffaf77;
      border: 1px solid #ffaf77;
      transition: 250ms;
      &:hover {
        background-color: #ffc399;
        border: 1px solid #ffc399;
      }
    `};
  ${props =>
    props.testimonial &&
    css`
      width: 150px;
      background: #ffaf77;
      border: 1px solid #ffaf77;
      border-radius: 0 4px 4px 0;
    `};
  ${props =>
    props.buy &&
    css`
      width: 150px;
      height: 45px;
      border-radius: 3px;
      background: ${props => (props.cta ? '#2a425e' : '#ffaf77')};
      color: #fff;
      line-height: 0;
      border: ${props => (props.cta ? '2px solid #fff' : '1px solid #ffaf77')};
      font-size: 1.2em;
    `};
  ${props =>
    props.footer &&
    css`
      padding: 0;
      height: 35px;
    `};
  ${props =>
    props.home &&
    css`
      height: 37px;
      border-radius: 3px;
      width: 195px;
      font-size: 18px;
      margin: 0.75em 0;
      font-weight: 400;
      background-color: #ffaf77;
      border: 1px solid #ffaf77;
      &:hover {
        background-color: #ffa566;
        border: 1px solid #ffa566;
      }
      @media (max-width: 450px) {
        width: 165px;
      }
    `};
  ${props =>
    props.add &&
    css`
      font-size: 18px;
      margin: 0.75em 0.5em;
      font-weight: 400;
      width: 200px;
      background-color: ${props => (props.close ? '#ccc' : '#ffaf77')};
      border: ${props =>
        props.close ? '1px solid #ccc' : '1px solid #ffaf77'};
      &:hover {
        background-color: ${props => (props.close ? '#bbb' : '#ffa566')};
        border: ${props =>
          props.close ? '1px solid #bbb' : '1px solid #ffa566'};
      }
      @media (max-width: 450px) {
        width: 165px;
      }
    `};
  ${props =>
    props.disable &&
    css`
      font-size: 18px;
      font-weight: 400;
      background-color: #ccc;
      border: 1px solid #ccc;
      cursor: default;
      @media (max-width: 450px) {
        width: 165px;
      }
    `};
`;

export const StyledNavLink = styled(NavLink)`
  font-size: 18px;
  font-family: 'Ubuntu', sans-serif;
  text-transform: uppercase;
  text-decoration: none;
  list-style: none;
  color: #fff;
  font-weight: 600;
  margin-right: 2em;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  ${props =>
    props.create &&
    css`
      background-color: #ffaf77;
      padding: 0.5em;
      border-radius: 3px;
    `};
  @media (max-width: 1100px) {
    font-size: 1.2em;
  }
  @media (max-width: 320px) {
    margin-right: 0;
  }
`;

export const Container = styled.div`
  width: 100%;
  padding: 40px 0;
  padding-bottom: ${props => props.paddingButtom || '0'};
  text-align: ${props => props.textalign || 'inherid'};
  background: ${props => props.background || 'white'};
`;

export const Grid = styled.div`
  width: 75%;
  display: grid;
  grid-gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(275px, 1fr));
  grid-auto-rows: 210px;
  margin: 2em auto;
  @media (max-width: 1100px) {
    width: 100%;
    margin: 1em auto;
  }
`;

export const Form = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 75%;
  @media (max-width: 780px) {
    flex-direction: column;
    width: 95%;
  }
`;

export const StyledRow = styled(Row)`
  position: relative;
  @media (max-width: 780px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const SubscribeEmail = styled.form`
  padding: 40px 0;

  input {
    padding: 15px;
    border-radius: 8px 0 0 8px;
    border: 1px solid #ccc;
  }

  button  {
    padding: 15px;
    border-radius: 0 8px 8px 0;
    border: 1px solid #fcaf78;
    background: #fcaf78;
    color: white;

    i {
      margin-right: 3px;
    }
  }

  input,
  button {
    border-radius: 0;
  }

  @media (min-width: 767px) {
    input,
    button {
      width: auto;
    }

    input {
      min-width: 330px;
      border-radius: 8px 0 0 8px;
      border: 1px solid #ccc;
    }

    button  {
      border-radius: 0 8px 8px 0;
      border: 1px solid #fcaf78;
      background: #fcaf78;
      color: white;

      i {
        margin-right: 3px;
      }
    }
  }
`;

export const LicenceErrorMessage = styled.div`
  float: right;
  display: flex;
  aligni-tems: flex-start;
  width: 290px;
  color: red;

  span {
    flex: 40%;
    text-align: right;
    padding-top: 3px;
  }

  ul {
    margin-top: 0;
    padding-left: 25px;
    flex: 60%;

    li {
      font-size: 14px;
      color: red;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/theme/index.js